<template>
  <div>
    <data-manage-page 
      ref="baseTable"
      :store-namespace="storeNamespace" 
      :props-filter="buildFilter()" 
      :tag-index="tagIndex" 
      :columns="columns"
      :fields="fields"
      :page="pagination"
      @update:selection="handleSelectionChange"
      @update:pagination="handlePaginationChange"
    >
      <!-- Custom action button -->
      <template #actions>
        <a-button type="primary" :loading="loadingcheckLiveUids" @click="handleCheckLive" icon="check"> Check live</a-button>
        <a-button type="primary" @click="handleAddTasks" icon="plus"> Thêm vào công việc</a-button>
      </template>

      <!-- Custom filters -->
      <template #filters>
        <a-form-model-item label="Status">
          <a-select placeholder="Status" style="width: 150px;" :allowClear="true" v-model="filter.status">
            <a-select-option :value="0"><a-tag>Unknown</a-tag></a-select-option>
            <a-select-option :value="1"><a-tag color="green">Active</a-tag></a-select-option>
            <a-select-option :value="2"><a-tag color="orange">Locked</a-tag></a-select-option>
            <a-select-option :value="3"><a-tag color="red">Suspended</a-tag></a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="2FA">
          <a-select placeholder="Trạng thái 2FA" style="width: 150px;" :allowClear="true" v-model="filter.tfa">
            <a-select-option :value="1"><a-tag color="green">Có</a-tag></a-select-option>
            <a-select-option :value="0"><a-tag>Không</a-tag></a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Rest ID">
          <a-select allowClear mode="tags" placeholder="Rest IDs" style="width: 200px;" v-model="filter.rest_ids">
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Quốc gia">
          <a-select allowClear mode="tags" placeholder="Countries" style="width: 200px;" v-model="filter.countries">
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Domains">
          <a-select allowClear mode="tags" placeholder="Domains" style="width: 200px;" v-model="filter.domains">
          </a-select>
        </a-form-model-item>
      </template>

      <!-- #region
        Custom render table 
      -->
      <a slot="uid" slot-scope="{ text }" :href="('https://x.com/' + text)" target="_blank">
        {{ text }}
      </a>

      <template slot="status" slot-scope="{ text }">
        <a-tag v-if="text == 0">Unknown</a-tag>
        <a-tag v-if="text == 1" color="green">Active</a-tag>
        <a-tag v-if="text == 2" color="orange">Locked</a-tag>
        <a-tag v-if="text == 3" color="red">Suspended</a-tag>
      </template>

      <template slot="country" slot-scope="{ text }">
        <a-tag v-if="!!text">{{ text.toUpperCase() }}</a-tag>
      </template>

      <template slot="tfa" slot-scope="{ text }">
        <a-icon v-if="!!text" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
      </template>

      <span slot="email" slot-scope="{ text }">{{ maskedEmail(text) }}</span>

      <template slot="tag_ids" slot-scope="{ record }">
        <template v-for="tag_id in record.tag_ids">
          <a-tag :key="tag_id" closable @close="handleUnassignTag(record.id, tag_id)"
            v-if="tagExisted(tag_id)">{{ getTagTitleById(tag_id) }}</a-tag>
        </template>
      </template>

      <template slot="operation" slot-scope="{ record }">
        <a href="javascript:;" v-if="!!record.has_ads" @click="showAds(record.fb_id)"><a-icon type="eye" /> ADS</a>
      </template>

      <a-badge v-if="text != null || text != undefined" :overflowCount="5001" slot="total_friends" slot-scope="{ text }"
        show-zero :count="text" :number-style="{ backgroundColor: '#999' }" 
      />

      <a-badge v-if="!!text" :overflowCount="3000" slot="birthday" slot-scope="{ text }" show-zero
        :count="new Date(text).getFullYear()" :number-style="{ backgroundColor: '#999' }" 
      />

      <span v-if="!!text" slot="registration_time" slot-scope="{ text }">
        {{ new Date(text).toLocaleString() }}
      </span>
      <!-- #endregion -->
       
    </data-manage-page>

    <!-- Modal check live -->
    <a-modal id="checklive-progress-modal" width="1000px" v-model="visible.checkliveProgressModal" title="Tiến trình checklive" @ok="() => visible.checkliveProgressModal = false">
      <div>
        Progress: <b>{{checkliveProgress.success}}</b> / <b>{{checkliveProgress.total}}</b>
      </div>
      <a-progress :percent="checkliveProgress.percent" :status="checkliveProgress.status" />
      <br><br>
      <div>Errors:</div>
      <a-list bordered v-if="checkliveProgress && checkliveProgress.errors.length > 0" :data-source="checkliveProgress.errors">
        <a-list-item slot="renderItem" slot-scope="error">
          <a-list-item-meta>
            <span slot="title">{{ error.message }}</span>
            <a-badge :overflowCount="9999999" slot="avatar" show-zero :count="error.count" :number-style="{ backgroundColor: '#999' }" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-modal>

    <!-- Choose Job modal -->
    <a-modal id="jobs-modal" width="1000px" v-model="visible.chooseJobModal" title="Danh sách công việc" @ok="() => visible.chooseJobModal = false">
      <div><p>Bạn đã chọn <b><i>{{selectedDataUids.length || pagination.total}}</i></b> accounts!</p></div>
      <div v-if="!jobs || jobs?.length == 0">Không có công việc nào!</div>
      <a-list :grid="{ gutter: 16, column: 3 }" :data-source="hasInputJobs">
        <a-list-item slot="renderItem" slot-scope="job">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="add" type="check" @click="chooseJobForAddTasks(job)"/>
            </template>
            <a-card-meta style="height: 115px; white-space: pre-wrap;text-overflow: ellipsis;overflow: hidden;" :title="job.metadata.title" :description="job.metadata.description">
            </a-card-meta>
            <div>Input: <a-badge showZero :count="job.input_count" :number-style="{
              backgroundColor: '#fff',
              color: '#999',
              boxShadow: '0 0 0 1px #d9d9d9 inset',
            }" /></div>
            <div>Kịch bản <b>{{job.metadata.scenario.title}}</b></div>
          </a-card>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<style></style>

<script>
import DataManagePage from '../data-layout/DataManagePage.vue';
import { mapActions, mapGetters } from 'vuex';

const fields = [
  { title: 'UID', key: 'uid' },
  { title: 'Password', key: 'password' },
  { title: '2FA', key: 'tfa' },
  { title: 'Mail', key: 'email' },
  { title: 'Mail pass', key: 'email_pass' },
  { title: 'Cookie', key: 'cookie' },
  { title: 'Backup codes', key: 'backup_codes' },
  { title: 'Status', key: 'status' },
  { title: 'Name', key: 'name' },
  { title: 'Registration time', key: 'registration_time' },
  { title: 'Note', key: 'note' },
  { title: 'Rest ID', key: 'rest_id' },
  { title: 'Auth token', key: 'auth_token' },
  { title: 'Device token', key: 'device_token' },
  { title: 'OAuth token', key: 'oauth_token' },
  { title: 'OAuth secret', key: 'oauth_secret' },
  { title: 'Country', key: 'country' },
  { title: 'Language', key: 'lang' },
  { title: 'Useragent', key: 'useragent' },
  { title: 'X Client UUID', key: 'headers.x-client-uuid' },
  { title: 'X Client DeviceId', key: 'headers.x-twitter-client-deviceid' },
  { title: 'Outlook Client ID', key: 'outlook_client_id' },
  { title: 'Outlook Refresh Token', key: 'outlook_refresh_token' },
];

const columns = [
  {
    title: 'UID',
    dataIndex: 'uid',
    key: 'uid',
    width: '180px',
    fixed: 'left',
    scopedSlots: { customRender: 'uid' }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: '120px',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '2FA',
    dataIndex: 'tfa',
    key: 'tfa',
    width: '60px',
    align: 'center',
    scopedSlots: { customRender: 'tfa' }
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    scopedSlots: { customRender: 'email' }
  },
  {
    title: 'Quốc gia',
    dataIndex: 'country',
    key: 'country',
    width: '90px',
    align: 'center',
    scopedSlots: { customRender: 'country' }
  },
  {
    title: 'Tags',
    dataIndex: 'tag_ids',
    key: 'tag_ids',
    scopedSlots: { customRender: 'tag_ids' }
  },
  {
    title: 'Tên',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Thời gian tạo',
    dataIndex: 'registration_time',
    key: 'registration_time',
    scopedSlots: { customRender: 'registration_time' }
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    fixed: 'right',
    width: '400px',
  },
  {
    title: 'Thao tác',
    fixed: 'right',
    width: '150px',
    scopedSlots: { customRender: 'operation' },
  }
];

export default {
  name: 'XAccount',
  components: {
    DataManagePage,
  },
  data() {
    return {
      app: this.$root.$children[0],
      columns,
      fields,
      filter: {},

      tagIndex: 'x-account',
      storeNamespace: 'xAccount',
      loadingcheckLiveUids: false,

      selectedData: [],
      selectedDataIds: [],
      selectedDataUids: [],

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
      },

      visible: {
        chooseJobModal: false,
        checkliveProgressModal: false,
      },

      checkliveProgress: {
        percent: 0,
        total: 0,
        success: 0,
        errors: [],
        status: "active"
      },
    };
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.buildFilter();
      },
    },
  },

  computed: {
    ...mapGetters('tag', {
      tags: 'getTags'
    }),

    ...mapGetters('job', {
      jobs: "getJobs"
    }),

    hasInputJobs() {
      return this.jobs.filter(j => j.has_input == true);
    }
  },

  methods: {
    ...mapActions("xAccount", {
      createCheckLiveUidsTask: "createCheckLiveUidsTask",
      createCheckLiveFilterTask: "createCheckLiveFilterTask",
      getCheckLiveTask: "getCheckLiveTask",
      checkLiveEmailFilter: "checkLiveEmailFilter",
      addJobInputs: "addJobInputs",
      unassignTag: "unassignTag",
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags",
      addTag: "addTag",
      assignTag: "assignTag",
      deleteTag: "deleteTag"
    }),

    ...mapActions("job", {
      addTasks: "addTasks",
      fetchJobs: "fetchJobs",
    }),

    handleSelectionChange(selection) {
      this.selectedDataIds = selection.selectedDataIds;
      this.selectedDataUids = selection.selectedDataUids;
      this.selectedData = selection.selectedData;
    },

    handlePaginationChange(pagination) {
      this.pagination.total = pagination.total;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    
    buildFilter() {
      const filter = {};

      if (typeof this.filter.status == 'number') {
        filter.status = this.filter.status;
      }

      if (typeof this.filter.tfa == 'number') {
        filter.tfa = this.filter.tfa;
      }

      if (this.filter.rest_ids && this.filter.rest_ids.length > 0) {
        filter.rest_ids = this.filter.rest_ids;
      }

      if (this.filter.countries && this.filter.countries?.length > 0) {
        filter.countries = this.filter.countries;
      }

      if (this.filter.domains && this.filter.domains?.length > 0) {
        filter.domains = this.filter.domains;
      }

      return filter;
    },

    maskedEmail(email) {
      if (!email) return '';
      const [name, domain] = email.split('@');
      if (!name || !domain) return email;
      
      const maskedName = name[0] + '*'.repeat(Math.max(name.length - 1, 1));
      
      return `${maskedName}@${domain}`;
    },

    getTagTitleById(tagId) {
      const tag = this.tagExisted(tagId);

      if (!tag) {
        return null;
      }

      return tag.title;
    },

    tagExisted(tagId) {
      if (tagId && this.tags.length > 0) {
        const tag = this.tags.find(tag => tag.id == tagId);

        if (tag) {
          return tag;
        }
      }

      return false;
    },

    async handleUnassignTag(id, tag_id) {
      this.app.callApi(async () => {
        await this.unassignTag({id, tag_id});
        this.$message.success('Gỡ tag thành công!');
      });
    },

    async handleCheckLiveProgress(taskId) {
      this.visible.checkliveProgressModal = true;

      const interval = setInterval(async () => {
        try {
          const {data} = await this.getCheckLiveTask({
            task_id: taskId
          });

          this.checkliveProgress.success = data.threading.success;
          this.checkliveProgress.total = data.threading.total;
          this.checkliveProgress.errors = data.threading.errors;
          this.checkliveProgress.percent = Number(parseFloat(data.threading.success / data.threading.total).toFixed(1)) * 100;
          this.checkliveProgress.status = data.threading.is_running ? "active" : undefined;

          if (!data.threading.is_running || (data.threading.success == data.threading.total)) {
            clearInterval(interval);
          }
        }
        catch(error) {
          clearInterval(interval);
        }
      }, 1000);
    },

    async handleCheckLive() {
      const uids = [...this.selectedDataUids];

      if (uids.length > 0) {
        const {message, data} = await this.createCheckLiveUidsTask({
          uids
        });
        this.$message.success(message);

        return this.handleCheckLiveProgress(data.task_id);
      }

      const handler = async () => {
        try {
          const filter = this.$refs.baseTable.buildFilter();
          const {message, data} = await this.createCheckLiveFilterTask(filter);
          this.$message.success(message);

          return this.handleCheckLiveProgress(data.task_id);
        }
        catch(error) {
          this.$message.error(error.response.data.message);
        }
      }

      this.$confirm({
        title: 'Bạn có chắc muốn check live toàn bộ dữ liệu với bộ lọc hiện tại?',
        content: `Khi bạn click OK, dữ liệu theo bộ lọc hiện tại gồm ${this.pagination.total} tài khoản sẽ được check live.`,
        onOk: handler
      });
    },

    async handleAddTasks() {
      await this.fetchJobs();
      this.visible.chooseJobModal = true;
    },

    async chooseJobForAddTasks(job) {
      const ids = [...this.selectedDataIds];

      try {
        const {message} = await this.addJobInputs({
          filter: (ids && ids.length > 0) ? {ids} : this.$refs.baseTable.buildFilter(),
          jobPid: job.metadata.id
        });
        this.$message.success(message);
      }
      catch(error) {
        this.$message.error(error.response.data.message);
      }
    },
  },
};
</script>